<template>
  <BootstrapTable
    :columns="columns"
    :data-url="data"
    :options="options"
    data-side-pagination="server"
    data-pagination="true"
  />
</template>

<script>
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'

  import axios from 'axios';
  import Noty from 'noty';

export default {

  beforeMount(){
    
    const mailinglistID = this.mailinglist;

  },
  components: {
    BootstrapTable
  },
  props: ['mailinglist'],
  data () {
    return {
      columns: [
        {
          field: 'first_name',
          title: 'First Name',
          sortable: true
        },
        {
          field: 'last_name',
          title: 'Last Name',
          sortable: true
        },
        {
          field: 'company_name',
          title: 'Company Name',
          sortable: true
        },
        {
          field: 'email',
          title: 'Email',
          sortable: true
        },
        {
          field: 'telephone',
          title: 'Mobile',
          sortable: true
        },
        {
          mailinglist: this.mailinglist,
          field: 'tools',
          title: 'Tools',

          formatter: function(value, row, index, field, mailinglist=this.mailinglist){

            var isOnMailinglist = row.mailinglists.map(o=>o['id']).includes(parseInt(mailinglist));

            if(isOnMailinglist){

              return [
                '<a class="table-control btn btn-primary btn-sm toggle-contact" data-mailinglist="'+mailinglist+'" href="javascript:void(0)">',
                  'Remove',
                '</a>',
              ].join('');

            }else{

              return [
                '<a class="table-control btn btn-green btn-sm toggle-contact" data-mailinglist="'+mailinglist+'" href="javascript:void(0)">',
                  'Add',
                '</a>',
              ].join('');

            }
          },
          width: 160,
          align: 'center',
          events: {
              'click .toggle-contact': function (e, value, row) {

                  var mailinglist = e.target.dataset.mailinglist;

                  var contact_id = row.id;

                  axios.get('/contacts/mailinglist/'+mailinglist+'/contact/toggle/'+contact_id).then(response => {

                    if(response.data.action == 'add'){

                      $(e.target).addClass('btn-primary').removeClass('btn-green').text('Remove');
                      
                      new Noty({
                        text: 'Contact Added to Mailinglist.',
                        type: 'success',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                      }).show();

                    }
                    if(response.data.action == 'remove'){

                      $(e.target).addClass('btn-green').removeClass('btn-primary').text('Add');

                       new Noty({
                        text: 'Contact Removed from Mailinglist.',
                        type: 'warning',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                      }).show();

                    }

                  }).catch(() => console.warn('Oh. Something went wrong. toggleContact'));

              }
            }
        }
      ],
      data: '/contacts/mailinglist/'+this.mailinglist+'/all-contacts/list',
      options: {
        search: true,
        searchTimeOut: 800,
      }
    }
  }


}



</script>